module.exports = __webpack_public_path__ + "img/public/SiteIcons/verifyFailed.svg?e21fe631";